import dayjs from "dayjs";
import { ProTable } from "@ant-design/pro-components";
import styles from "./index.less";

import { ResponseCode } from "@/constants";
import { ResourceType } from "@/services/order";
import { getSeatListService } from "@/services/user";
import { SeatTermTypeEnum } from "@/services/resource";
import classNames from "classnames";

type SeatTableProps = {
  value?: string[];
  onChange?: (value: string[]) => void;
};
export default function SeatTable(props: SeatTableProps) {
  const { value, onChange } = props;

  return (
    <ProTable
      className={classNames(
        "pagination-item-active-12-times",
        styles["pro-table"]
      )}
      tableAlertRender={false}
      rowSelection={{
        preserveSelectedRowKeys: true,
        selectedRowKeys: value,
        onChange(selectedRowKeys) {
          onChange?.(selectedRowKeys as string[]);
        },
      }}
      rowKey={"resourceId"}
      columns={[
        {
          title: "序号",
          dataIndex: "seq",
          render(_, _record, index) {
            return index + 1;
          },
        },
        {
          title: "到期日期",
          dataIndex: "endTime",
          sorter: {},
          renderText: (text: string) => dayjs(text).format("YYYY-MM-DD"),
        },
      ]}
      options={false}
      search={false}
      request={async ({ pageSize, current }, sort) => {
        const rsp = await getSeatListService({
          pageSize,
          pageNum: current,
          resourceType: ResourceType.ENTERPRISE_WECHAT_SEAT,
          sort: sort?.endTime
            ? sort?.endTime === "ascend"
              ? "ASC"
              : "DESC"
            : undefined,
          termType: SeatTermTypeEnum.SHORT,
        });
        return {
          total: rsp.data?.total,
          success: rsp.code === ResponseCode.Success,
          data: rsp.data?.records,
        };
      }}
      pagination={{ defaultPageSize: 6, showSizeChanger: true }}
    />
  );
}
